import React from 'react';
import { Hero } from './components/Hero';
import { OpeningHook } from './components/OpeningHook';
import { Problem } from './components/Problem';
import { WhyItFailed } from './components/WhyItFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsFor } from './components/WhoIsFor';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { PriceBlock } from './components/PriceBlock';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-terracotta/20 selection:text-brown" data-id="element-0">
      <Hero data-id="element-1" />
      <OpeningHook data-id="element-2" />
      <Problem data-id="element-3" />
      <WhyItFailed data-id="element-4" />
      <Mechanism data-id="element-5" />
      <WhatYouGet data-id="element-6" />
      <WhoIsFor data-id="element-7" />
      <HowItWorks data-id="element-8" />
      <Proof data-id="element-9" />
      <FAQ data-id="element-10" />
      <PriceBlock data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}